export default {
    install: (app) => {
        app.config.globalProperties.$getAssetUrlPlugin = (assetPath) => {
            const sanitizedPath = assetPath.replace(/^\/+/, '');
            return 'https://cdn.grouptogether.com/' + sanitizedPath; // Define your global function
        };
    },
};
